import adminClient from "./adminClient"
import serviciosV2Client from "../../helpers/serviciosV2Client"

const BASE = "presupuestos"

const cleanParams = obj =>
  Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== "" && v !== null && v !== undefined),
  )

// ───────── Listar / Detalle ─────────

/**
 * GET /presupuestos
 * Filtros opcionales: empresaId, sucursalId (uuid o "null" literal para nivel empresa),
 * anio, estado (BORRADOR | APROBADO | ACTIVO | CERRADO | CANCELADO)
 */
export const listarPresupuestos = (filtros = {}) =>
  adminClient.get(BASE, { params: cleanParams(filtros) })

/** GET /presupuestos/:id — detalle completo (periodos, categorías, versiones, padre) */
export const obtenerPresupuesto = (id) =>
  adminClient.get(`${BASE}/${encodeURIComponent(id)}`)

/** GET /presupuestos/:id/historial — últimos 100 movimientos de auditoría */
export const obtenerHistorial = (id) =>
  adminClient.get(`${BASE}/${encodeURIComponent(id)}/historial`)

// ───────── Crear / Actualizar / Eliminar ─────────

/**
 * POST /presupuestos
 * Body: { empresaId, sucursalId?, nombre, descripcion?, anio, periodicidad,
 *         fechaInicio, fechaFin, tipoMedicion?, moneda?, montoTotal?,
 *         unidadesTotal?, notas? }
 */
export const crearPresupuesto = (data) =>
  adminClient.post(BASE, data)

/** PUT /presupuestos/:id — actualizar cabecera (sólo en BORRADOR/APROBADO/CANCELADO) */
export const actualizarPresupuesto = (id, data) =>
  adminClient.put(`${BASE}/${encodeURIComponent(id)}`, data)

/** DELETE /presupuestos/:id — soft delete (no permite ACTIVO) */
export const eliminarPresupuesto = (id) =>
  adminClient.delete(`${BASE}/${encodeURIComponent(id)}`)

// ───────── Periodos / Distribución / Categorías ─────────

/**
 * PUT /presupuestos/:id/periodos
 * Body: { periodos: [{ id, montoObjetivo?, unidadesObjetivo?, notas? }, ...] }
 * El back recalcula montoTotal y unidadesTotal de la cabecera.
 */
export const actualizarPeriodos = (id, periodos) =>
  adminClient.put(`${BASE}/${encodeURIComponent(id)}/periodos`, { periodos })

/**
 * POST /presupuestos/:id/distribuir
 * Body LINEAL:  { metodo: "LINEAL", montoTotal?, unidadesTotal? }
 * Body MANUAL:  { metodo: "MANUAL", montoTotal, unidadesTotal, porcentajes: [...] }
 */
export const distribuirPresupuesto = (id, data) =>
  adminClient.post(`${BASE}/${encodeURIComponent(id)}/distribuir`, data)

/**
 * PUT /presupuestos/:id/categorias
 * Body: { reemplazarTodo?: boolean, categorias: [{ periodoId, codigoCategoria,
 *         nombreCategoria, tipoCategoria?, montoObjetivo?, unidadesObjetivo? }, ...] }
 */
export const actualizarCategorias = (id, data) =>
  adminClient.put(`${BASE}/${encodeURIComponent(id)}/categorias`, data)

// ───────── Estado / Versionado ─────────

/**
 * POST /presupuestos/:id/estado
 * Body: { estado: "APROBADO" | "ACTIVO" | "CERRADO" | "CANCELADO" }
 * Falla 409 si la transición es inválida.
 */
export const cambiarEstado = (id, estado) =>
  adminClient.post(`${BASE}/${encodeURIComponent(id)}/estado`, { estado })

/**
 * POST /presupuestos/:id/clonar
 * Body opcional: { nombre?, notas? }
 * Crea copia en BORRADOR con version = N+1.
 */
export const clonarPresupuesto = (id, data = {}) =>
  adminClient.post(`${BASE}/${encodeURIComponent(id)}/clonar`, data)

// ───────── Helpers de otros módulos ─────────

/** GET /admin/api/empresas/mis-empresas — lista de empresas del usuario */
export const listarEmpresas = () =>
  adminClient.get("empresas/mis-empresas")

/** GET /admin/api/empresas/:id/sucursales — sucursales de una empresa */
export const listarSucursalesEmpresa = (empresaId) =>
  adminClient.get(`empresas/${encodeURIComponent(empresaId)}/sucursales`)

// ───────── Cruce con ventas reales del facturador (servicesV2) ─────────

/**
 * GET servicesV2/analytics/dashboard
 * Devuelve KPIs reales del facturador para un rango. Se usa para cruzar
 * con los objetivos del presupuesto y calcular cumplimiento por periodo.
 *
 * Params: { nitemisor, fecha_inicio, fecha_fin, sucursal? }
 */
export const getVentasReales = ({ nitemisor, fecha_inicio, fecha_fin, sucursal }) =>
  serviciosV2Client.get("analytics/dashboard", {
    params: cleanParams({ nitemisor, fecha_inicio, fecha_fin, sucursal }),
  })

export default adminClient
